import * as React from "react";
const SvgCamera20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M13.535 2h-7.07l-2 3H0v13h20V5h-4.465l-2-3Zm-8 5 2-3h4.93l2 3H18v9H2V7h3.535ZM8 10.5a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm2-4a4 4 0 1 0 0 8 4 4 0 0 0 0-8Z",
      clipRule: "evenodd"
    })
  );
export default SvgCamera20Px;
